import { useEffect, useRef } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Lenis from "lenis";
import { Toaster } from "sonner";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import WhatsAppFloat from "@/components/WhatsAppFloat";
import Home from "@/pages/Home";
import QuemSomos from "@/pages/QuemSomos";
import Solucoes from "@/pages/Solucoes";
import ComoTrabalhamos from "@/pages/ComoTrabalhamos";
import Contato from "@/pages/Contato";

const LenisScroll = ({ children }) => {
    const location = useLocation();
    const lenisRef = useRef(null);

    useEffect(() => {
        const lenis = new Lenis({ lerp: 0.09, smoothWheel: true });
        lenisRef.current = lenis;
        let raf;
        const loop = (t) => {
            lenis.raf(t);
            raf = requestAnimationFrame(loop);
        };
        raf = requestAnimationFrame(loop);
        return () => {
            cancelAnimationFrame(raf);
            lenis.destroy();
        };
    }, []);

    useEffect(() => {
        lenisRef.current?.scrollTo(0, { immediate: true });
        window.scrollTo(0, 0);
    }, [location.pathname]);

    return children;
};

function App() {
    return (
        <div className="App">
            <BrowserRouter>
                <LenisScroll>
                    <Navbar />
                    <Routes>
                        <Route path="/" element={<Home />} />
                        <Route path="/quem-somos" element={<QuemSomos />} />
                        <Route path="/solucoes" element={<Solucoes />} />
                        <Route path="/como-trabalhamos" element={<ComoTrabalhamos />} />
                        <Route path="/contato" element={<Contato />} />
                    </Routes>
                    <Footer />
                    <WhatsAppFloat />
                    <Toaster position="top-center" richColors closeButton />
                </LenisScroll>
            </BrowserRouter>
        </div>
    );
}

export default App;
